import React from 'react';
import styled from 'styled-components';
import {StyledCard,StyledCardHead,StyledCardName,StyledCardMeta,StyledStats,StyledStat,StyledStatValue,StyledStatLabel} from '../../../../Team/components/TableContainer/components/Table/squadCardStyled';
import {simplifiedPosition,rangeColor,formRangeColor} from '../../../../../service/data';
import RatingCell from '../../RatingCell';
import PotentialCell from '../../PotentialCell';
import NameCell from '../../NameCell';
import TeamOwnerIcon from '../../TeamOwnerIcon';
const Card=styled(StyledCard)`
 .card-head {display:grid;grid-template-columns:minmax(0,1fr) auto;gap:5px 12px;align-items:center;}
 .context {grid-column:2;grid-row:1 / 3;display:flex;flex-direction:column;align-items:flex-end;gap:4px;text-align:right;}
 .club {grid-column:1;}
 .club button {overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}
 .identity {display:flex;align-items:center;gap:8px;text-align:left;border:0;background:none;padding:0;color:inherit;cursor:pointer;width:100%;}
 .identity > span:first-child {overflow:hidden;text-overflow:ellipsis;min-width:0;}
 .club {display:flex;align-items:center;gap:6px;min-width:0;}
 .club button {border:0;background:none;padding:0;color:inherit;text-align:left;text-decoration:underline;cursor:pointer;font:inherit;}
 .footer {display:flex;align-items:center;justify-content:space-between;gap:8px;padding:8px 12px;border-top:1px solid ${({theme})=>theme.borderSubtle};}
 .footer > div {flex:0 0 auto;width:auto;}
 .footer .action-cell {width:auto;height:32px;}
 .status {white-space:nowrap;font-size:11px;color:${({theme})=>theme.textFaint};}
 .stats {box-sizing:border-box;}
 .stats > div {font-size:12px;}
 .value > span {font:inherit;color:inherit;}

`;
export default function SearchPlayerCard({row,selected,onSelect,onClub,ownerKind,actions}) {
 const player=row.original,cell={row};
 return <Card as="article" $selected={selected}>
  <StyledCardHead className="card-head">
   <StyledCardName as="button" className="identity" type="button" onClick={onSelect}><NameCell cell={cell}/></StyledCardName>
   <StyledCardMeta className="club"><TeamOwnerIcon kind={ownerKind} tooltipId={`search-card-team-${row.id}`}/>{player.teamName!=='Free agent' && player.team?<button type="button" onClick={onClub}>{player.teamName}</button>:<span>{player.teamName || 'Free agent'}</span>}</StyledCardMeta>
   <StyledCardMeta className="context"><span>{player.leagueName}</span>{player.favZone && <span>{player.favZone}</span>}</StyledCardMeta>
  </StyledCardHead>
  <StyledStats className="stats">
   <StyledStat><StyledStatValue>{simplifiedPosition[player.fav_position] || player.fav_position || '—'}</StyledStatValue><StyledStatLabel>Position</StyledStatLabel></StyledStat>
   <StyledStat><StyledStatValue>{player.age}</StyledStatValue><StyledStatLabel>Age</StyledStatLabel></StyledStat>
   <StyledStat><StyledStatValue as="div" className="value" $color={rangeColor[player.ratingValue]} title={player.ratingValue}><RatingCell cell={cell}/></StyledStatValue><StyledStatLabel>Rating</StyledStatLabel></StyledStat>
   <StyledStat><StyledStatValue as="div" className="value" $color={rangeColor[player.potentialValue]} title={player.potentialValue}><PotentialCell cell={cell}/></StyledStatValue><StyledStatLabel>Potential</StyledStatLabel></StyledStat>
   <StyledStat><StyledStatValue $color={formRangeColor[player.form]}>{player.form || '—'}</StyledStatValue><StyledStatLabel>Fitness</StyledStatLabel></StyledStat>
  </StyledStats>
  <div className="footer"><span className="status">{player.scoutResults}</span>{actions}</div>
 </Card>;
}
